import React, { useEffect, useState } from 'react';
import moment from 'moment';
import media from 'styled-media-query';
import styled from 'styled-components';
import useAxios from 'axios-hooks'
import ControlsMenu from 'containers/advanced/ControlsMenu';
import Info from 'components/advanced/Info';

const InfoWrapper = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
grid-column-gap: 1rem;
grid-row-gap: 1rem;
align-items: center;
justify-items: start;
`;

// Rated power is the turbine's own admin setting (windTurbine.maxPower, kW),
// the same field the dashboard gauge and the info modal read. It was a
// hardcoded '60 kW' here, so every turbine showed 60 whatever its setting.
// Availability comes from Orbital-server's GET /historyData/availability
// (minutes that produced a history snapshot in the last 24h / minutes
// expected). It was a hardcoded '99.1%'. null/undefined = not loaded yet or
// no data to compute it from.
const formatAvailability = (availability) =>
  typeof availability === 'number' ? `${availability.toFixed(1)}%` : 'N/A';

const getInfoData = (windTurbine, availability) => [{
  icon: 'lightning',
  title: 'Rated turbine power',
  subtitle: windTurbine && windTurbine.maxPower ? `${windTurbine.maxPower} kW` : 'N/A',
}, {
  icon: 'clock outline',
  title: '24h Connection availability',
  subtitle: formatAvailability(availability),
}];

const addLogToData = (windTurbine, logs, availability) => {
  const data = getInfoData(windTurbine, availability);

  if (logs.length > 0) {
    return data.concat([{
      icon: 'calendar outline',
      title: 'Latest log',
      subtitle: moment(logs[0].updatedAt).format('D MMMM YYYY, HH:mm:ss'),
    }, {
      icon: 'calendar alternate outline',
      title: 'First log',
      subtitle: moment(logs[logs.length - 1].updatedAt).format('D MMMM YYYY, HH:mm:ss'),
    }]);
  }

  return data.concat([{
    icon: 'calendar outline',
    title: 'Latest log',
    subtitle: 'N/A',
  }, {
    icon: 'calendar alternate outline',
    title: 'First log',
    subtitle: 'N/A',
  }]);
};

const Advanced = ({
  windTurbine,
  subscribeToLiveParams,
  unsubscribeFromLiveParams,
 }) => {
  const [actionLogs, setActionLogs] = useState([]);

  const [{ data }] = useAxios({
    url: `/actionLogs/${windTurbine.id}`,
    method: "GET",
    fetchPolicy: 'no-cache'
  });

  const [{ data: availabilityData }] = useAxios({
    url: `/historyData/availability`,
    method: "GET",
    params: { windTurbineId: windTurbine.id },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    subscribeToLiveParams([windTurbine, { from: "monitoring" }]);
  });

  useEffect(() => {
    return () => {
      console.log("++ UNMOUNT DETAIL LIVE", windTurbine.id);
      windTurbine.from = "monitoring";
      //need this to have the expected format in the unsubscribeFromLiveParams() function
      let wtArr = [];
      wtArr[windTurbine.id] = windTurbine;
      unsubscribeFromLiveParams({ ...wtArr });
    };
  }, [unsubscribeFromLiveParams]);

  useEffect(() => {
    if (data) {
      setActionLogs(data || []);
    }
  }, [data]);

  // Built at render (not stored in state) so the rated power follows
  // windTurbine.maxPower if it changes or loads after the first paint.
  const renderItems = () => (
    addLogToData(windTurbine, actionLogs, availabilityData && availabilityData.availability).map(d => (
      <div key={d.title}>
        <Info icon={d.icon} title={d.title} subtitle={d.subtitle} />
      </div>
    ))
  );

  return (
    <div>
      <InfoWrapper>
        {renderItems()}
      </InfoWrapper>
      <ControlsMenu windTurbine={windTurbine} />
    </div>
  )
};

export default Advanced;
